import { render, staticRenderFns } from "./Registration.vue?vue&type=template&id=3ce5dab2&scoped=true&"
import script from "./Registration.vue?vue&type=script&lang=js&"
export * from "./Registration.vue?vue&type=script&lang=js&"
import style0 from "./index.scss?vue&type=style&index=0&id=3ce5dab2&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ce5dab2",
  null
  
)

export default component.exports